export default function addOrRemoveObjectToArray<T>(list: T[], item: T, comparisonProperty: any): T[] {
    const carrierIndex = list.findIndex((c) => c[comparisonProperty] === item[comparisonProperty])
    if (carrierIndex === -1) {
        return [...list, item]
    }

    return list.filter((c) => c[comparisonProperty] !== item[comparisonProperty]);
}